module.exports = __webpack_public_path__ + "static/img/ios1.5.7488fc93.jpg";